// @charset "utf-8"
/* eslint-disable no-undef */
/* eslint-disable no-new */
import cookieApi from '@/lib/cookieApi'
const state = {
    userName: cookieApi.get('escapename'),
    userId: cookieApi.get('userid')
}
const mutations = {

}
const actions = {

}

const getters = {
    userName (state) {
        return state.userName
    },
    userId (state) {
        return state.userId
    }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/userInfo.js